module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DataTablePage', {
    attrs: {
      "mainColumn": "",
      "longColumn": "",
      "title": "数据历史查询",
      "label": "数据历史",
      "labelName": "num",
      "resource": _vm.resource,
      "requestData": _vm.requestData,
      "columns": _vm.columns,
      "tableInitList": _vm.tableInitList,
      "tableFullList": _vm.tableFullList,
      "filterInitList": _vm.filterInitList
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-589b55d8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/NB/DataQueryHistory.vue
// module id = 1756
// module chunks = 1